<template>
  <div class="login">
    <p class="register" @click="$router.push('/register')">注册</p>
    <h1 class="title">登录</h1>
    <LoginInput
      placeholderpaw="请输入密码"
      :codeBtn="false"
      loginBtn="登录"
      :serviceFlag="false"
      @clickBtn="clickBtn"
    />
    <router-link to="/phone-login" style="color:#666">验证码登录</router-link>
  </div>
</template>

<script>
import LoginInput from "../../components/LoginInput";
export default {
  name: "Login",
  data() {
    return {};
  },
  components: {
    LoginInput
  },
  methods: {
    clickBtn(obj) {
      let myreg = /^13[\d]{9}$|^14[5,7]{1}\d{8}$|^15[^4]{1}\d{8}$|^17[0,3,6,7,8]{1}\d{8}$|^18[\d]{9}$/;
      let userName = obj.phone;
      if (!obj.dragSuccess) {
        this.$toast("请拖动滑块完成验证");
        return;
      }
      if (!myreg.test(userName)) {
        this.$toast("请输入正确的手机号");
        return;
      }
      let params = {
        phone: userName,
        password: obj.paw
      };
      this.$store
        .dispatch("Login", params)
        .then(() => { 
          this.$toast.success("登录成功");
          this.$router.push({ path: "/" });
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.login {
  padding: 0 30px;
}
.register {
  text-align: right;
  padding-top: 55px;
  font-size: 30px;
  color: #666;
}
.title {
  font-size: 50px;
  margin: 95px 0 165px 0;
}
</style>